import React, { useState } from 'react';
import styled from '@emotion/styled';

import { Button, Modal } from '../lumen';
import { notifier } from '../actions';

export const ActionModal = ({
  title,
  submitLabel,
  submittingLabel,
  submitVariant = 'dark',
  fallbackErrorMessage,
  disabled = false,
  footerStart,
  size,
  width,
  onSubmit,
  onClose,
  children
}) => {
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = () => {
    if (submitting || disabled) return;
    setSubmitting(true);
    Promise.resolve()
      .then(onSubmit)
      .catch(err => {
        setSubmitting(false);
        notifier.error(err?.message || fallbackErrorMessage);
      });
  };

  const handleFormSubmit = event => {
    event.preventDefault();
    handleSubmit();
  };

  return (
    <Modal
      open
      title={title}
      onClose={onClose}
      size={size}
      width={width}
      footer={
        <>
          {footerStart && <FooterStart>{footerStart}</FooterStart>}
          <Button variant="default" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button
            type="submit"
            form="action-modal-form"
            variant={submitVariant}
            onClick={handleSubmit}
            disabled={submitting || disabled}
            aria-busy={submitting}
          >
            {submitting ? submittingLabel : submitLabel}
          </Button>
        </>
      }
    >
      <form id="action-modal-form" onSubmit={handleFormSubmit}>
        {children}
      </form>
    </Modal>
  );
};

const FooterStart = styled.div`
  margin-right: auto;
  display: flex;
  align-items: center;
`;
